<template>

  <!--
  <section class="lp_top_image">
    <img src="@/assets/img/tmf2026/tmf2026_speech.jpg" />
  </section>
  -->

  <h1 class="text-center">受賞者スピーチ</h1>

  <section class="column_content mt-5">
    <div class="album_wrap">

      <a
        href="https://youtu.be/NuStr7Wg4M0"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="@/assets/img/tmf2026/speech_1.jpeg"
          alt="受賞者スピーチ1"
        >
      </a>

      <a
        href="https://youtu.be/Q6DmQ69Fs68"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="@/assets/img/tmf2026/speech_2.jpeg"
          alt="受賞者スピーチ2"
        >
      </a>

      <a
        href="https://youtu.be/HyNMd0W6tD8"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="@/assets/img/tmf2026/speech_3.jpeg"
          alt="受賞者スピーチ3"
        >
      </a>

      <a
        href="https://youtu.be/b0Hyz04w1Ps"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="@/assets/img/tmf2026/speech_4.jpeg"
          alt="受賞者スピーチ4"
        >
      </a>

      <a
        href="https://youtu.be/y6qRQ95Kc8E"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="@/assets/img/tmf2026/speech_5.jpeg"
          alt="受賞者スピーチ5"
        >
      </a>

      <a
        href="https://youtu.be/5IUU8htuZOY"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="@/assets/img/tmf2026/speech_6.jpeg"
          alt="受賞者スピーチ6"
        >
      </a>

      <a
        href="https://youtu.be/-GacFK1iaRg"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="@/assets/img/tmf2026/speech_7.jpeg"
          alt="受賞者スピーチ7"
        >
      </a>

      <a
        href="https://youtu.be/rz0Nyo2gZfA"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="@/assets/img/tmf2026/speech_8.jpeg"
          alt="受賞者スピーチ8"
        >
      </a>

      <a
        href="https://youtu.be/mkE2RBIG0os"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="@/assets/img/tmf2026/speech_9.jpeg"
          alt="受賞者スピーチ9"
        >
      </a>

      <a
        href="https://youtu.be/JFn2ZGqRgOY"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="@/assets/img/tmf2026/speech_10.jpeg"
          alt="受賞者スピーチ10"
        >
      </a>

      <a
        href="https://youtu.be/mIULurWWV0Q"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="@/assets/img/tmf2026/speech_11.jpeg"
          alt="受賞者スピーチ11"
        >
      </a>

      <a
        href="https://youtu.be/en9ifxFqE2c"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="@/assets/img/tmf2026/speech_12.jpeg"
          alt="受賞者スピーチ12"
        >
      </a>

      <a
        href="https://youtu.be/5gxaNzjoML8"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="@/assets/img/tmf2026/speech_13.jpeg"
          alt="受賞者スピーチ13"
        >
      </a>

      <a
        href="https://youtu.be/eKa518CPLvE"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="@/assets/img/tmf2026/speech_14.jpeg"
          alt="受賞者スピーチ14"
        >
      </a>

    </div>
  </section>

  <div class="box-p-20 text-center">
    <router-link to="/lp/tmf2026" class="btn d-inline-block">THE MANAVIS FESTIVAL 2026<br>トップに戻る</router-link>
  </div>

  <!-- トップに戻るボタン -->
  <button
    id="page-top"
    class="btn"
    type="button"
    @click="scrollTop"
  >
    TOP
  </button>

</template>

<style scoped>
/* アルバム一覧 */
.album_wrap {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 15px;
  margin-bottom: 50px;
}

/* 各YouTubeリンク */
.album_wrap > a {
  display: block;
  width: 100%;
  min-width: 0;
  overflow: hidden;
}

/* サムネイル画像 */
.album_wrap > a img {
  display: block;
  width: 100%;
  height: auto;
}

/* マウスを重ねたとき */
.album_wrap > a:hover img {
  opacity: 0.8;
}

.column_content h2,
.column_content h3 {
  font-weight: 500 !important;
}

small {
  font-size: 0.7em;
}

/* TOPボタン */
button#page-top {
  position: fixed;
  left: 20px;
  bottom: 20px;
  z-index: 100;
}

/* タブレット */
@media screen and (max-width: 991px) {
  .album_wrap {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

/* スマートフォン */
@media screen and (max-width: 767px) {
  .album_wrap {
    grid-template-columns: 1fr;
    gap: 15px;
  }
}
</style>

<script>
import $ from "jquery";

export default {
  mounted() {
    window.scrollTo(0, 0);

    const topBtn = $("#page-top");

    topBtn.hide();

    $(window).on("scroll.speechAlbum", function() {
      if ($(this).scrollTop() > 500) {
        topBtn.fadeIn();
      } else {
        topBtn.fadeOut();
      }
    });
  },

  beforeUnmount() {
    /*
     * ページ移動後もスクロールイベントが残らないように解除
     */
    $(window).off("scroll.speechAlbum");
  },

  methods: {
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>